import uploadService from '../../services/uploadService'

const state = {
  recentUploads: null,
}

const getters = {
  getRecentUploadsSummary(state) {
    return state.recentUploads
  },
}

const mutations = {
  setRecentUploads(state, payload) {
    state.recentUploads = payload
  },
}

const actions = {
  loadRecentUploadsSummary({commit}) {
    return uploadService.getRecentUploadsSummary()
      .then(uploads => {
        commit('setRecentUploads', uploads)
        return uploads
      })
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/-service-app/store/modules/uploadStore.js